
<template>
  <v-dialog max-width="600px" v-model="showDialog">
    <v-btn flat fab slot="activator" style='margin-top:-20px' 
      class="indigo accent-1"
      light small mt-4 absolute middle right ><v-icon>add</v-icon>
    </v-btn>

    <v-card>
      <v-card-title>
        <h2>Define a new code of type {{showCodeSet()}} </h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form"  onSubmit="return false;">
          <v-layout mx-3 my-3 column>
            <v-flex xs6 offset-xs0>
               <v-layout row>
                <v-flex xs12>
                  <v-text-field  v-if="showDialog" autofocus v-model="code.name" name='codeName' label="Code name"
                    :rules="[rules.required, rules.min]" />
                </v-flex>
              </v-layout>
              <provenance-and-note v-bind:record="code"/>
              <v-layout row>
                <v-flex xs12>
                  <div class="error" v-html="error"></div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-btn dark class="indigo darken-1" @click='createCode' :loading="loading"><v-icon left >save_alt</v-icon> Define New Code</v-btn>
                </v-flex>
              </v-layout>         
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>        

<script>

import Panel from '@/components/Panel' ;
import CodeService from "@/services/CodeService" ;

export default {
  components: { Panel },
  props: {
    codes: null,
    options: null,
    data: null      // all the code types and code ids and vals
  },
  data () {
    return {
      code: {  
        name: '',
        type: 'XX',
        provenance: '',
        note: ''
      },
      error: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 3 || 'Minimum of 3 characters is required.'
      },
      loading: false,
      showDialog: false
    }
  },

  methods: {
    async createCode () {

      console.log("IN createCode") ; 
      if (!this.$refs.form.validate()) return ;
      this.error = '' ;
      try {
        this.code.type = this.codes[this.options.currentCode].code ;
        this.loading = true ;
        const response = await CodeService.create(this.code) ;
        console.log("create code response: " + JSON.stringify(response)) ;
        this.data[this.code.type].push(response.data) ;
        this.showDialog = false ;
        this.$renderToastInParent(this, "Code " + this.code.name + " successfully created") ;
      }
      catch (err) {
        console.log("catch err:" + err) ;
        this.error = err.response.data.error 
      }
      finally {
        this.loading = false ;
      }
    },
    showCodeSet () {
      return this.codes[this.options.currentCode].v ;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CodeCreate.vue